module.exports = __webpack_public_path__ + "static/card03_04-d7c0adc798a20a962cfd63647fb9bbf3.png";